import {EntityType} from "../../../gd/const/item"
import type Goal from "../../../model2/goal/goal"   // type only: a value import would load goal.ts too early
import Relation from "../../../model2/relation/relation"
import goToProjectItem from "./go-to-project-item"

// Open the related item in the CURRENT window. Most types delegate to their
// model's `goTo`; GOAL spells it `openGoal`, PROJECT needs the link's metadata.
//
// MIRRORED BY `item-route-url.ts`, the same routes as a string for a new window
// -- add a type here and add it there too. USER links are never shown.
export default function goToItem(relation: Relation) {
    switch (relation.itemType) {
        case EntityType.PROJECT : return goToProjectItem(relation)
        case EntityType.GOAL    : return (relation.relatedItem as Goal).openGoal()

        case EntityType.TASK    :
        case EntityType.EVENT   :
        case EntityType.MEETING :
        case EntityType.DOCUMENT: return relation.relatedItem.goTo()
    }
}
